/// <reference path="./custom.d.ts" />
// tslint:disable
/**
 * account-management-business
 * account-management-business-api
 *
 * OpenAPI spec version: 2.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */


import * as Url from 'url'

const url = Url as any
url.URLSearchParams = URLSearchParams

/**
 *
 *@export
 *@interface FetchArgs
 */
export interface FetchArgs {
  url: string;
  options: any;
  abort: () => void
}

/**
 *
 *@export
 *@class RequiredError
 *@extends {Error}
 */
export class RequiredError extends Error {
  name = "RequiredError"

  constructor(public field: string, msg?: string) {
    super(msg);
  }
}

/**
 * 
 * @export
 * @interface AccountProfileResponse
 */
export interface AccountProfileResponse {
    /**
     * Account's Country Code
     * @type {string}
     * @memberof AccountProfileResponse
     */
    country_code?: string;
    /**
     * Account's Email
     * @type {string}
     * @memberof AccountProfileResponse
     */
    email?: string;
    /**
     * Account's Language
     * @type {string}
     * @memberof AccountProfileResponse
     */
    language?: string;
    /**
     * Account's Phone Number
     * @type {string}
     * @memberof AccountProfileResponse
     */
    phone_number?: string;
}

/**
 * 
 * @export
 * @interface AvailableOrganizationResponse
 */
export interface AvailableOrganizationResponse {
    /**
     * organization prime key
     * @type {string}
     * @memberof AvailableOrganizationResponse
     */
    id?: string;
    /**
     * organization customized domain prefix
     * @type {string}
     * @memberof AvailableOrganizationResponse
     */
    org_domain_prefix?: string;
    /**
     * organization name
     * @type {string}
     * @memberof AvailableOrganizationResponse
     */
    org_name?: string;
    /**
     * organization site
     * @type {string}
     * @memberof AvailableOrganizationResponse
     */
    org_site?: string;
}

/**
 * 
 * @export
 * @interface ChangeAccountPhoneNumberRequest
 */
export interface ChangeAccountPhoneNumberRequest {
    /**
     * Action Ticket(VerifyEmailSecurityCode.Response)
     * @type {string}
     * @memberof ChangeAccountPhoneNumberRequest
     */
    action_ticket: string;
    /**
     * SMS security code
     * @type {string}
     * @memberof ChangeAccountPhoneNumberRequest
     */
    code: string;
    /**
     * 手机号区号,例如中国大陆: +86，美国、加拿大：+1
     * @type {string}
     * @memberof ChangeAccountPhoneNumberRequest
     */
    country_code: string;
    /**
     * Phone Number
     * @type {string}
     * @memberof ChangeAccountPhoneNumberRequest
     */
    phone_number: string;
}

/**
 * 
 * @export
 * @interface CommonBooleanResponse
 */
export interface CommonBooleanResponse {
    /**
     * 
     * @type {boolean}
     * @memberof CommonBooleanResponse
     */
    is_success?: boolean;
}

/**
 * 
 * @export
 * @interface CommonStringResponse
 */
export interface CommonStringResponse {
    /**
     * 
     * @type {string}
     * @memberof CommonStringResponse
     */
    data?: string;
}

/**
 * 
 * @export
 * @interface EmailSecurityCodeVerificationRequest
 */
export interface EmailSecurityCodeVerificationRequest {
    /**
     * Email event
     * @type {string}
     * @memberof EmailSecurityCodeVerificationRequest
     */
    event: EmailSecurityCodeVerificationRequest.EventEnum;
    /**
     * SMS Security Code
     * @type {string}
     * @memberof EmailSecurityCodeVerificationRequest
     */
    security_code: string;
}

/**
 * @export
 * @namespace EmailSecurityCodeVerificationRequest
 */
export namespace EmailSecurityCodeVerificationRequest {
    /**
     * @export
     * @enum {string}
     */
    export enum EventEnum {
        SECURITY = <any> 'SECURITY',
        CHANGEPHONENUMBERSECURITY = <any> 'CHANGE_PHONE_NUMBER_SECURITY',
        CHANGEICUSERPHONENUMBERSECURITY = <any> 'CHANGE_IC_USER_PHONE_NUMBER_SECURITY',
        CHANGEICUSERSUPERADMINSECURITY = <any> 'CHANGE_IC_USER_SUPER_ADMIN_SECURITY',
        CHANGEORGANIZATIONUSERSUPERADMINSECURITY = <any> 'CHANGE_ORGANIZATION_USER_SUPER_ADMIN_SECURITY'
    }
}

/**
 * 
 * @export
 * @interface EmailVerifyActionTicketResponse
 */
export interface EmailVerifyActionTicketResponse {
    /**
     * 
     * @type {string}
     * @memberof EmailVerifyActionTicketResponse
     */
    action_ticket?: string;
}

/**
 * 
 * @export
 * @interface GetMFABindingInfoRequest
 */
export interface GetMFABindingInfoRequest {
    /**
     * SMS Security Code
     * @type {string}
     * @memberof GetMFABindingInfoRequest
     */
    sms_security_code: string;
}

/**
 * 
 * @export
 * @interface MFABindingStatusResponse
 */
export interface MFABindingStatusResponse {
    /**
     * Account's Email
     * @type {string}
     * @memberof MFABindingStatusResponse
     */
    email?: string;
    /**
     * Account's MFA Binding status
     * @type {boolean}
     * @memberof MFABindingStatusResponse
     */
    is_bound?: boolean;
}

/**
 * 
 * @export
 * @interface MFASetUpRequest
 */
export interface MFASetUpRequest {
    /**
     * TOTP Security Code
     * @type {string}
     * @memberof MFASetUpRequest
     */
    totp_security_code: string;
}

/**
 * 
 * @export
 * @interface MFATotpVerificationRequest
 */
export interface MFATotpVerificationRequest {
    /**
     * TOTP Security Code
     * @type {string}
     * @memberof MFATotpVerificationRequest
     */
    totp_security_code: string;
}

/**
 * 
 * @export
 * @interface SetAccountOrganizationRequest
 */
export interface SetAccountOrganizationRequest {
    /**
     * 
     * @type {string}
     * @memberof SetAccountOrganizationRequest
     */
    org_id?: string;
}

/**
 * 
 * @export
 * @interface SingleSendEmailEventRequest
 */
export interface SingleSendEmailEventRequest {
    /**
     * Email event
     * @type {string}
     * @memberof SingleSendEmailEventRequest
     */
    event: SingleSendEmailEventRequest.EventEnum;
}

/**
 * @export
 * @namespace SingleSendEmailEventRequest
 */
export namespace SingleSendEmailEventRequest {
    /**
     * @export
     * @enum {string}
     */
    export enum EventEnum {
        SECURITY = <any> 'SECURITY',
        CHANGEPHONENUMBERSECURITY = <any> 'CHANGE_PHONE_NUMBER_SECURITY',
        CHANGEICUSERPHONENUMBERSECURITY = <any> 'CHANGE_IC_USER_PHONE_NUMBER_SECURITY',
        CHANGEICUSERSUPERADMINSECURITY = <any> 'CHANGE_IC_USER_SUPER_ADMIN_SECURITY',
        CHANGEORGANIZATIONUSERSUPERADMINSECURITY = <any> 'CHANGE_ORGANIZATION_USER_SUPER_ADMIN_SECURITY'
    }
}

/**
 * 
 * @export
 * @interface SingleSendSMSEventRequest
 */
export interface SingleSendSMSEventRequest {
    /**
     * SMS Event
     * @type {string}
     * @memberof SingleSendSMSEventRequest
     */
    event: SingleSendSMSEventRequest.EventEnum;
}

/**
 * @export
 * @namespace SingleSendSMSEventRequest
 */
export namespace SingleSendSMSEventRequest {
    /**
     * @export
     * @enum {string}
     */
    export enum EventEnum {
        REGISTER = <any> 'REGISTER',
        MFA = <any> 'MFA',
        CHANGEPHONENUMBER = <any> 'CHANGE_PHONE_NUMBER',
        CREATEBUSINESSOPENAPISECRETKEY = <any> 'CREATE_BUSINESS_OPEN_API_SECRET_KEY',
        CHANGEBUSINESSOPENAPISECRETKEYSTATUS = <any> 'CHANGE_BUSINESS_OPEN_API_SECRET_KEY_STATUS',
        DELETEBUSINESSOPENAPISECRETKEY = <any> 'DELETE_BUSINESS_OPEN_API_SECRET_KEY'
    }
}

/**
 * 
 * @export
 * @interface SingleSendSMSRequest
 */
export interface SingleSendSMSRequest {
    /**
     * 手机号区号,例如中国大陆: +86，美国、加拿大：+1
     * @type {string}
     * @memberof SingleSendSMSRequest
     */
    country_code: string;
    /**
     * SMS Event
     * @type {string}
     * @memberof SingleSendSMSRequest
     */
    event: SingleSendSMSRequest.EventEnum;
    /**
     * Phone Number
     * @type {string}
     * @memberof SingleSendSMSRequest
     */
    phone_number: string;
}

/**
 * @export
 * @namespace SingleSendSMSRequest
 */
export namespace SingleSendSMSRequest {
    /**
     * @export
     * @enum {string}
     */
    export enum EventEnum {
        REGISTER = <any> 'REGISTER',
        MFA = <any> 'MFA',
        CHANGEPHONENUMBER = <any> 'CHANGE_PHONE_NUMBER',
        CREATEBUSINESSOPENAPISECRETKEY = <any> 'CREATE_BUSINESS_OPEN_API_SECRET_KEY',
        CHANGEBUSINESSOPENAPISECRETKEYSTATUS = <any> 'CHANGE_BUSINESS_OPEN_API_SECRET_KEY_STATUS',
        DELETEBUSINESSOPENAPISECRETKEY = <any> 'DELETE_BUSINESS_OPEN_API_SECRET_KEY'
    }
}

/**
 * 
 * @export
 * @interface UpdateLanguageRequest
 */
export interface UpdateLanguageRequest {
    /**
     * Language
     * @type {string}
     * @memberof UpdateLanguageRequest
     */
    language: UpdateLanguageRequest.LanguageEnum;
}

/**
 * @export
 * @namespace UpdateLanguageRequest
 */
export namespace UpdateLanguageRequest {
    /**
     * @export
     * @enum {string}
     */
    export enum LanguageEnum {
        ZhCN = <any> 'zh-CN',
        EnUS = <any> 'en-US'
    }
}




export interface IgetAvailableOrganizationListUsingGETParams {
  
  
  
  
}
export interface IgetProfileUsingGETParams {
  
  
  
  
}
export interface IsetAccountOrganizationUsingPOSTParams {
  request: SetAccountOrganizationRequest, 
  
  
  
}
export interface IsetLanguageUsingPUTParams {
  request: UpdateLanguageRequest, 
  
  
  
}

/**
 *AccountControllerApi - fetch parameter creator
 *@export
 */
export const AccountControllerApiParamCreator = {
  /**
    *
    *@summary retrieve account's available organization list
    *@param {string} cookie 
    *@param {*} [options] Override http request option.
    *@throws {RequiredError}
  */
  getAvailableOrganizationListUsingGET(params = {} as IgetAvailableOrganizationListUsingGETParams, options: any = {}): FetchArgs {
    const {     } = params



    const prefix = "https://internal-api.test.tableau-shanghai-test.com/business/v1/account".split("internal-api.test.tableau-shanghai-test.com")[1]
    let localVarPath = `/business/v1/account/profile/available_organizations`.includes(prefix) ? `/business/v1/account/profile/available_organizations` : prefix + `/business/v1/account/profile/available_organizations`
    if (process.env.NODE_ENV !== 'test') {
      localVarPath = localVarPath;
    }
    const localVarUrlObj = url.parse(localVarPath, true);
    const controller = new AbortController();
    const { signal } = controller;
    const localVarRequestOptions = { method: 'GET', signal, ...options };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;



    localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
    // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
    Reflect.deleteProperty(localVarUrlObj, 'search')
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers}
    return {
      url: url.format(localVarUrlObj),
      ...localVarRequestOptions,
      signal,
      abort: () => controller.abort.call(controller)
    };
  },
  /**
    *
    *@summary retrieve account's profile
    *@param {string} cookie 
    *@param {*} [options] Override http request option.
    *@throws {RequiredError}
  */
  getProfileUsingGET(params = {} as IgetProfileUsingGETParams, options: any = {}): FetchArgs {
    const {     } = params



    const prefix = "https://internal-api.test.tableau-shanghai-test.com/business/v1/account".split("internal-api.test.tableau-shanghai-test.com")[1]
    let localVarPath = `/business/v1/account/profile`.includes(prefix) ? `/business/v1/account/profile` : prefix + `/business/v1/account/profile`
    if (process.env.NODE_ENV !== 'test') {
      localVarPath = localVarPath;
    }
    const localVarUrlObj = url.parse(localVarPath, true);
    const controller = new AbortController();
    const { signal } = controller;
    const localVarRequestOptions = { method: 'GET', signal, ...options };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;



    localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
    // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
    Reflect.deleteProperty(localVarUrlObj, 'search')
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers}
    return {
      url: url.format(localVarUrlObj),
      ...localVarRequestOptions,
      signal,
      abort: () => controller.abort.call(controller)
    };
  },
  /**
    *
    *@summary set account's available organization by specific organization ID
    *@param {string} cookie 
    *@param {SetAccountOrganizationRequest} request request
    *@param {*} [options] Override http request option.
    *@throws {RequiredError}
  */
  setAccountOrganizationUsingPOST(params = {} as IsetAccountOrganizationUsingPOSTParams, options: any = {}): FetchArgs {
    const { request,     } = params
    // verify required body 'request' is not null or undefined
    if (request === null || request === undefined) {
      if (process.env.NODE_ENV !== 'test')
        throw new RequiredError('request', 'Required parameter request was null or undefined when calling setAccountOrganizationUsingPOST.');
    }



    const prefix = "https://internal-api.test.tableau-shanghai-test.com/business/v1/account".split("internal-api.test.tableau-shanghai-test.com")[1]
    let localVarPath = `/business/v1/account/profile/set_organization`.includes(prefix) ? `/business/v1/account/profile/set_organization` : prefix + `/business/v1/account/profile/set_organization`
    if (process.env.NODE_ENV !== 'test') {
      localVarPath = localVarPath;
    }
    const localVarUrlObj = url.parse(localVarPath, true);
    const controller = new AbortController();
    const { signal } = controller;
    const localVarRequestOptions = { method: 'POST', signal, ...options };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;



    localVarHeaderParameter['Content-Type'] = 'application/json';

    localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
    // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
    Reflect.deleteProperty(localVarUrlObj, 'search')
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers}
    const needsSerialization =
      (<any>"SetAccountOrganizationRequest" !== "string") ||
      localVarRequestOptions.headers['Content-Type'] === 'application/json';
    localVarRequestOptions.body =  needsSerialization ? JSON.stringify(request || {}) : (request || "");
    return {
      url: url.format(localVarUrlObj),
      ...localVarRequestOptions,
      signal,
      abort: () => controller.abort.call(controller)
    };
  },
  /**
    *
    *@summary set account's language
    *@param {string} cookie 
    *@param {UpdateLanguageRequest} request request
    *@param {*} [options] Override http request option.
    *@throws {RequiredError}
  */
  setLanguageUsingPUT(params = {} as IsetLanguageUsingPUTParams, options: any = {}): FetchArgs {
    const { request,     } = params
    // verify required body 'request' is not null or undefined
    if (request === null || request === undefined) {
      if (process.env.NODE_ENV !== 'test')
        throw new RequiredError('request', 'Required parameter request was null or undefined when calling setLanguageUsingPUT.');
    }



    const prefix = "https://internal-api.test.tableau-shanghai-test.com/business/v1/account".split("internal-api.test.tableau-shanghai-test.com")[1]
    let localVarPath = `/business/v1/account/profile/language`.includes(prefix) ? `/business/v1/account/profile/language` : prefix + `/business/v1/account/profile/language`
    if (process.env.NODE_ENV !== 'test') {
      localVarPath = localVarPath;
    }
    const localVarUrlObj = url.parse(localVarPath, true);
    const controller = new AbortController();
    const { signal } = controller;
    const localVarRequestOptions = { method: 'PUT', signal, ...options };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;



    localVarHeaderParameter['Content-Type'] = 'application/json';

    localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
    // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
    Reflect.deleteProperty(localVarUrlObj, 'search')
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers}
    const needsSerialization =
      (<any>"UpdateLanguageRequest" !== "string") ||
      localVarRequestOptions.headers['Content-Type'] === 'application/json';
    localVarRequestOptions.body =  needsSerialization ? JSON.stringify(request || {}) : (request || "");
    return {
      url: url.format(localVarUrlObj),
      ...localVarRequestOptions,
      signal,
      abort: () => controller.abort.call(controller)
    };
  },
};



export interface IsingleSendSMSUsingPOSTParams {
  request: SingleSendSMSRequest, 
  ticket: string, 
  
  
}

/**
 *OpenSecurityControllerApi - fetch parameter creator
 *@export
 */
export const OpenSecurityControllerApiParamCreator = {
  /**
    *
    *@summary Single send SMS security code by phone number
    *@param {string} ticket Activation ticket
    *@param {string} cookie 
    *@param {SingleSendSMSRequest} request request
    *@param {*} [options] Override http request option.
    *@throws {RequiredError}
  */
  singleSendSMSUsingPOST(params = {} as IsingleSendSMSUsingPOSTParams, options: any = {}): FetchArgs {
    const { request,   ticket,   } = params
    // verify required body 'request' is not null or undefined
    if (request === null || request === undefined) {
      if (process.env.NODE_ENV !== 'test')
        throw new RequiredError('request', 'Required parameter request was null or undefined when calling singleSendSMSUsingPOST.');
    }


    // verify required query 'ticket' is not null or undefined
    if (ticket === null || ticket === undefined) {
      if (process.env.NODE_ENV !== 'test')
        throw new RequiredError('ticket', 'Required parameter ticket was null or undefined when calling singleSendSMSUsingPOST.');
    }

    const prefix = "https://internal-api.test.tableau-shanghai-test.com/business/v1/account".split("internal-api.test.tableau-shanghai-test.com")[1]
    let localVarPath = `/business/v1/account/open_security/sms`.includes(prefix) ? `/business/v1/account/open_security/sms` : prefix + `/business/v1/account/open_security/sms`
    if (process.env.NODE_ENV !== 'test') {
      localVarPath = localVarPath;
    }
    const localVarUrlObj = url.parse(localVarPath, true);
    const controller = new AbortController();
    const { signal } = controller;
    const localVarRequestOptions = { method: 'POST', signal, ...options };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    if (ticket !== undefined) {
        localVarQueryParameter.ticket = ticket;
    }



    localVarHeaderParameter['Content-Type'] = 'application/json';

    localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
    // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
    Reflect.deleteProperty(localVarUrlObj, 'search')
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers}
    const needsSerialization =
      (<any>"SingleSendSMSRequest" !== "string") ||
      localVarRequestOptions.headers['Content-Type'] === 'application/json';
    localVarRequestOptions.body =  needsSerialization ? JSON.stringify(request || {}) : (request || "");
    return {
      url: url.format(localVarUrlObj),
      ...localVarRequestOptions,
      signal,
      abort: () => controller.abort.call(controller)
    };
  },
};



export interface IchangePhoneNumberUsingPOSTParams {
  request: ChangeAccountPhoneNumberRequest, 
  
  
  
}
export interface IgetMFABindingInfoUsingPOSTParams {
  request: GetMFABindingInfoRequest, 
  
  
  
}
export interface IgetMFAStatusUsingGETParams {
  
  
  
  
}
export interface IsetUpMFAUsingPOSTParams {
  request: MFASetUpRequest, 
  
  
  
}
export interface IsingleSendEmailUsingPOSTParams {
  request: SingleSendEmailEventRequest, 
  
  
  
}
export interface IsingleSendSMSByAssignedPhoneNumberUsingPOSTParams {
  request: SingleSendSMSRequest, 
  
  
  
}
export interface IsingleSendSMSUsingPOST1Params {
  request: SingleSendSMSEventRequest, 
  
  
  
}
export interface IverifyEmailSecurityCodeUsingPOSTParams {
  request: EmailSecurityCodeVerificationRequest, 
  
  
  
}
export interface IverifyMFATotpCodeUsingPOSTParams {
  request: MFATotpVerificationRequest, 
  
  
  
}

/**
 *SecurityControllerApi - fetch parameter creator
 *@export
 */
export const SecurityControllerApiParamCreator = {
  /**
    *
    *@summary change account's phone number
    *@param {string} cookie 
    *@param {ChangeAccountPhoneNumberRequest} request request
    *@param {*} [options] Override http request option.
    *@throws {RequiredError}
  */
  changePhoneNumberUsingPOST(params = {} as IchangePhoneNumberUsingPOSTParams, options: any = {}): FetchArgs {
    const { request,     } = params
    // verify required body 'request' is not null or undefined
    if (request === null || request === undefined) {
      if (process.env.NODE_ENV !== 'test')
        throw new RequiredError('request', 'Required parameter request was null or undefined when calling changePhoneNumberUsingPOST.');
    }



    const prefix = "https://internal-api.test.tableau-shanghai-test.com/business/v1/account".split("internal-api.test.tableau-shanghai-test.com")[1]
    let localVarPath = `/business/v1/account/security/change_phone_number`.includes(prefix) ? `/business/v1/account/security/change_phone_number` : prefix + `/business/v1/account/security/change_phone_number`
    if (process.env.NODE_ENV !== 'test') {
      localVarPath = localVarPath;
    }
    const localVarUrlObj = url.parse(localVarPath, true);
    const controller = new AbortController();
    const { signal } = controller;
    const localVarRequestOptions = { method: 'POST', signal, ...options };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;



    localVarHeaderParameter['Content-Type'] = 'application/json';

    localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
    // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
    Reflect.deleteProperty(localVarUrlObj, 'search')
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers}
    const needsSerialization =
      (<any>"ChangeAccountPhoneNumberRequest" !== "string") ||
      localVarRequestOptions.headers['Content-Type'] === 'application/json';
    localVarRequestOptions.body =  needsSerialization ? JSON.stringify(request || {}) : (request || "");
    return {
      url: url.format(localVarUrlObj),
      ...localVarRequestOptions,
      signal,
      abort: () => controller.abort.call(controller)
    };
  },
  /**
    *
    *@summary retrieve account's MFA Binding Info
    *@param {string} cookie 
    *@param {GetMFABindingInfoRequest} request request
    *@param {*} [options] Override http request option.
    *@throws {RequiredError}
  */
  getMFABindingInfoUsingPOST(params = {} as IgetMFABindingInfoUsingPOSTParams, options: any = {}): FetchArgs {
    const { request,     } = params
    // verify required body 'request' is not null or undefined
    if (request === null || request === undefined) {
      if (process.env.NODE_ENV !== 'test')
        throw new RequiredError('request', 'Required parameter request was null or undefined when calling getMFABindingInfoUsingPOST.');
    }



    const prefix = "https://internal-api.test.tableau-shanghai-test.com/business/v1/account".split("internal-api.test.tableau-shanghai-test.com")[1]
    let localVarPath = `/business/v1/account/security/mfa_info`.includes(prefix) ? `/business/v1/account/security/mfa_info` : prefix + `/business/v1/account/security/mfa_info`
    if (process.env.NODE_ENV !== 'test') {
      localVarPath = localVarPath;
    }
    const localVarUrlObj = url.parse(localVarPath, true);
    const controller = new AbortController();
    const { signal } = controller;
    const localVarRequestOptions = { method: 'POST', signal, ...options };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;



    localVarHeaderParameter['Content-Type'] = 'application/json';

    localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
    // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
    Reflect.deleteProperty(localVarUrlObj, 'search')
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers}
    const needsSerialization =
      (<any>"GetMFABindingInfoRequest" !== "string") ||
      localVarRequestOptions.headers['Content-Type'] === 'application/json';
    localVarRequestOptions.body =  needsSerialization ? JSON.stringify(request || {}) : (request || "");
    return {
      url: url.format(localVarUrlObj),
      ...localVarRequestOptions,
      signal,
      abort: () => controller.abort.call(controller)
    };
  },
  /**
    *
    *@summary retrieve account's MFA binding status
    *@param {string} cookie 
    *@param {*} [options] Override http request option.
    *@throws {RequiredError}
  */
  getMFAStatusUsingGET(params = {} as IgetMFAStatusUsingGETParams, options: any = {}): FetchArgs {
    const {     } = params



    const prefix = "https://internal-api.test.tableau-shanghai-test.com/business/v1/account".split("internal-api.test.tableau-shanghai-test.com")[1]
    let localVarPath = `/business/v1/account/security/mfa_config_status`.includes(prefix) ? `/business/v1/account/security/mfa_config_status` : prefix + `/business/v1/account/security/mfa_config_status`
    if (process.env.NODE_ENV !== 'test') {
      localVarPath = localVarPath;
    }
    const localVarUrlObj = url.parse(localVarPath, true);
    const controller = new AbortController();
    const { signal } = controller;
    const localVarRequestOptions = { method: 'GET', signal, ...options };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;



    localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
    // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
    Reflect.deleteProperty(localVarUrlObj, 'search')
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers}
    return {
      url: url.format(localVarUrlObj),
      ...localVarRequestOptions,
      signal,
      abort: () => controller.abort.call(controller)
    };
  },
  /**
    *
    *@summary set up account's MFA Shared Secret
    *@param {string} cookie 
    *@param {MFASetUpRequest} request request
    *@param {*} [options] Override http request option.
    *@throws {RequiredError}
  */
  setUpMFAUsingPOST(params = {} as IsetUpMFAUsingPOSTParams, options: any = {}): FetchArgs {
    const { request,     } = params
    // verify required body 'request' is not null or undefined
    if (request === null || request === undefined) {
      if (process.env.NODE_ENV !== 'test')
        throw new RequiredError('request', 'Required parameter request was null or undefined when calling setUpMFAUsingPOST.');
    }



    const prefix = "https://internal-api.test.tableau-shanghai-test.com/business/v1/account".split("internal-api.test.tableau-shanghai-test.com")[1]
    let localVarPath = `/business/v1/account/security/mfa_config`.includes(prefix) ? `/business/v1/account/security/mfa_config` : prefix + `/business/v1/account/security/mfa_config`
    if (process.env.NODE_ENV !== 'test') {
      localVarPath = localVarPath;
    }
    const localVarUrlObj = url.parse(localVarPath, true);
    const controller = new AbortController();
    const { signal } = controller;
    const localVarRequestOptions = { method: 'POST', signal, ...options };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;



    localVarHeaderParameter['Content-Type'] = 'application/json';

    localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
    // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
    Reflect.deleteProperty(localVarUrlObj, 'search')
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers}
    const needsSerialization =
      (<any>"MFASetUpRequest" !== "string") ||
      localVarRequestOptions.headers['Content-Type'] === 'application/json';
    localVarRequestOptions.body =  needsSerialization ? JSON.stringify(request || {}) : (request || "");
    return {
      url: url.format(localVarUrlObj),
      ...localVarRequestOptions,
      signal,
      abort: () => controller.abort.call(controller)
    };
  },
  /**
    *
    *@summary Single send Email security code
    *@param {string} cookie 
    *@param {SingleSendEmailEventRequest} request request
    *@param {*} [options] Override http request option.
    *@throws {RequiredError}
  */
  singleSendEmailUsingPOST(params = {} as IsingleSendEmailUsingPOSTParams, options: any = {}): FetchArgs {
    const { request,     } = params
    // verify required body 'request' is not null or undefined
    if (request === null || request === undefined) {
      if (process.env.NODE_ENV !== 'test')
        throw new RequiredError('request', 'Required parameter request was null or undefined when calling singleSendEmailUsingPOST.');
    }



    const prefix = "https://internal-api.test.tableau-shanghai-test.com/business/v1/account".split("internal-api.test.tableau-shanghai-test.com")[1]
    let localVarPath = `/business/v1/account/security/email`.includes(prefix) ? `/business/v1/account/security/email` : prefix + `/business/v1/account/security/email`
    if (process.env.NODE_ENV !== 'test') {
      localVarPath = localVarPath;
    }
    const localVarUrlObj = url.parse(localVarPath, true);
    const controller = new AbortController();
    const { signal } = controller;
    const localVarRequestOptions = { method: 'POST', signal, ...options };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;



    localVarHeaderParameter['Content-Type'] = 'application/json';

    localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
    // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
    Reflect.deleteProperty(localVarUrlObj, 'search')
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers}
    const needsSerialization =
      (<any>"SingleSendEmailEventRequest" !== "string") ||
      localVarRequestOptions.headers['Content-Type'] === 'application/json';
    localVarRequestOptions.body =  needsSerialization ? JSON.stringify(request || {}) : (request || "");
    return {
      url: url.format(localVarUrlObj),
      ...localVarRequestOptions,
      signal,
      abort: () => controller.abort.call(controller)
    };
  },
  /**
    *
    *@summary Single send SMS security code by Assigned Phone Number
    *@param {string} cookie 
    *@param {SingleSendSMSRequest} request request
    *@param {*} [options] Override http request option.
    *@throws {RequiredError}
  */
  singleSendSMSByAssignedPhoneNumberUsingPOST(params = {} as IsingleSendSMSByAssignedPhoneNumberUsingPOSTParams, options: any = {}): FetchArgs {
    const { request,     } = params
    // verify required body 'request' is not null or undefined
    if (request === null || request === undefined) {
      if (process.env.NODE_ENV !== 'test')
        throw new RequiredError('request', 'Required parameter request was null or undefined when calling singleSendSMSByAssignedPhoneNumberUsingPOST.');
    }



    const prefix = "https://internal-api.test.tableau-shanghai-test.com/business/v1/account".split("internal-api.test.tableau-shanghai-test.com")[1]
    let localVarPath = `/business/v1/account/security/sms_phone`.includes(prefix) ? `/business/v1/account/security/sms_phone` : prefix + `/business/v1/account/security/sms_phone`
    if (process.env.NODE_ENV !== 'test') {
      localVarPath = localVarPath;
    }
    const localVarUrlObj = url.parse(localVarPath, true);
    const controller = new AbortController();
    const { signal } = controller;
    const localVarRequestOptions = { method: 'POST', signal, ...options };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;



    localVarHeaderParameter['Content-Type'] = 'application/json';

    localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
    // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
    Reflect.deleteProperty(localVarUrlObj, 'search')
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers}
    const needsSerialization =
      (<any>"SingleSendSMSRequest" !== "string") ||
      localVarRequestOptions.headers['Content-Type'] === 'application/json';
    localVarRequestOptions.body =  needsSerialization ? JSON.stringify(request || {}) : (request || "");
    return {
      url: url.format(localVarUrlObj),
      ...localVarRequestOptions,
      signal,
      abort: () => controller.abort.call(controller)
    };
  },
  /**
    *
    *@summary Single send SMS security code
    *@param {string} cookie 
    *@param {SingleSendSMSEventRequest} request request
    *@param {*} [options] Override http request option.
    *@throws {RequiredError}
  */
  singleSendSMSUsingPOST1(params = {} as IsingleSendSMSUsingPOST1Params, options: any = {}): FetchArgs {
    const { request,     } = params
    // verify required body 'request' is not null or undefined
    if (request === null || request === undefined) {
      if (process.env.NODE_ENV !== 'test')
        throw new RequiredError('request', 'Required parameter request was null or undefined when calling singleSendSMSUsingPOST1.');
    }



    const prefix = "https://internal-api.test.tableau-shanghai-test.com/business/v1/account".split("internal-api.test.tableau-shanghai-test.com")[1]
    let localVarPath = `/business/v1/account/security/sms`.includes(prefix) ? `/business/v1/account/security/sms` : prefix + `/business/v1/account/security/sms`
    if (process.env.NODE_ENV !== 'test') {
      localVarPath = localVarPath;
    }
    const localVarUrlObj = url.parse(localVarPath, true);
    const controller = new AbortController();
    const { signal } = controller;
    const localVarRequestOptions = { method: 'POST', signal, ...options };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;



    localVarHeaderParameter['Content-Type'] = 'application/json';

    localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
    // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
    Reflect.deleteProperty(localVarUrlObj, 'search')
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers}
    const needsSerialization =
      (<any>"SingleSendSMSEventRequest" !== "string") ||
      localVarRequestOptions.headers['Content-Type'] === 'application/json';
    localVarRequestOptions.body =  needsSerialization ? JSON.stringify(request || {}) : (request || "");
    return {
      url: url.format(localVarUrlObj),
      ...localVarRequestOptions,
      signal,
      abort: () => controller.abort.call(controller)
    };
  },
  /**
    *
    *@summary Verify Email security code
    *@param {string} cookie 
    *@param {EmailSecurityCodeVerificationRequest} request request
    *@param {*} [options] Override http request option.
    *@throws {RequiredError}
  */
  verifyEmailSecurityCodeUsingPOST(params = {} as IverifyEmailSecurityCodeUsingPOSTParams, options: any = {}): FetchArgs {
    const { request,     } = params
    // verify required body 'request' is not null or undefined
    if (request === null || request === undefined) {
      if (process.env.NODE_ENV !== 'test')
        throw new RequiredError('request', 'Required parameter request was null or undefined when calling verifyEmailSecurityCodeUsingPOST.');
    }



    const prefix = "https://internal-api.test.tableau-shanghai-test.com/business/v1/account".split("internal-api.test.tableau-shanghai-test.com")[1]
    let localVarPath = `/business/v1/account/security/email_verify`.includes(prefix) ? `/business/v1/account/security/email_verify` : prefix + `/business/v1/account/security/email_verify`
    if (process.env.NODE_ENV !== 'test') {
      localVarPath = localVarPath;
    }
    const localVarUrlObj = url.parse(localVarPath, true);
    const controller = new AbortController();
    const { signal } = controller;
    const localVarRequestOptions = { method: 'POST', signal, ...options };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;



    localVarHeaderParameter['Content-Type'] = 'application/json';

    localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
    // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
    Reflect.deleteProperty(localVarUrlObj, 'search')
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers}
    const needsSerialization =
      (<any>"EmailSecurityCodeVerificationRequest" !== "string") ||
      localVarRequestOptions.headers['Content-Type'] === 'application/json';
    localVarRequestOptions.body =  needsSerialization ? JSON.stringify(request || {}) : (request || "");
    return {
      url: url.format(localVarUrlObj),
      ...localVarRequestOptions,
      signal,
      abort: () => controller.abort.call(controller)
    };
  },
  /**
    *
    *@summary verify mfa totp code
    *@param {string} cookie 
    *@param {MFATotpVerificationRequest} request request
    *@param {*} [options] Override http request option.
    *@throws {RequiredError}
  */
  verifyMFATotpCodeUsingPOST(params = {} as IverifyMFATotpCodeUsingPOSTParams, options: any = {}): FetchArgs {
    const { request,     } = params
    // verify required body 'request' is not null or undefined
    if (request === null || request === undefined) {
      if (process.env.NODE_ENV !== 'test')
        throw new RequiredError('request', 'Required parameter request was null or undefined when calling verifyMFATotpCodeUsingPOST.');
    }



    const prefix = "https://internal-api.test.tableau-shanghai-test.com/business/v1/account".split("internal-api.test.tableau-shanghai-test.com")[1]
    let localVarPath = `/business/v1/account/security/mfa_verify`.includes(prefix) ? `/business/v1/account/security/mfa_verify` : prefix + `/business/v1/account/security/mfa_verify`
    if (process.env.NODE_ENV !== 'test') {
      localVarPath = localVarPath;
    }
    const localVarUrlObj = url.parse(localVarPath, true);
    const controller = new AbortController();
    const { signal } = controller;
    const localVarRequestOptions = { method: 'POST', signal, ...options };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;



    localVarHeaderParameter['Content-Type'] = 'application/json';

    localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
    // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
    Reflect.deleteProperty(localVarUrlObj, 'search')
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers}
    const needsSerialization =
      (<any>"MFATotpVerificationRequest" !== "string") ||
      localVarRequestOptions.headers['Content-Type'] === 'application/json';
    localVarRequestOptions.body =  needsSerialization ? JSON.stringify(request || {}) : (request || "");
    return {
      url: url.format(localVarUrlObj),
      ...localVarRequestOptions,
      signal,
      abort: () => controller.abort.call(controller)
    };
  },
};


